import { WebPage } from 'schema-dts';
import { siteUrl } from '..';
import { MetaProps } from '../../../../types/IHeader';

export const webPage = (
  data: MetaProps,
  localeCode: string,
  localeSlug: string,
  uri: string,
): WebPage => {
  return {
    '@type': 'WebPage',
    '@id': `${siteUrl}${uri}`,
    url: `${siteUrl}${uri}`,
    name: data?.metaFields?.title || data?.hero?.[0]?.title,
    description: data?.metaFields?.description || data?.hero?.[0]?.subtitle,
    primaryImageOfPage: {
      '@id': `${siteUrl}${uri}#primaryimage`,
    },
    isPartOf: {
      '@id': `${siteUrl}/${localeSlug}#website`,
    },
    about: {
      '@id': `${siteUrl}/${localeSlug}#organization`,
    },
    breadcrumb: {
      '@id': `${siteUrl}${uri}#breadcrumb`,
    },
    potentialAction: [
      {
        '@type': 'ReadAction',
        target: `${siteUrl}${uri}`,
      },
    ],
    inLanguage: localeCode,
    datePublished: data?.meta?.publishedAt,
    dateModified: data?.meta?.updatedAt,
  };
};
